import { Button } from '@mui/material';
import { isProductionEnvironment } from 'shared/envUtils';

export const ClearDataButton = (): JSX.Element | null => {
  const handleClearData = (): void => {
    if (isProductionEnvironment()) {
      return;
    }

    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };

  if (isProductionEnvironment()) {
    return null;
  }

  return (
    <Button
      color="error"
      onClick={handleClearData}
      size="small"
      variant="text"
      // eslint-disable-next-line i18next/no-literal-string
    >
      Debug: Clear App Data
    </Button>
  );
};
